module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Daniil Ratgauz (1868–1937) was first noticed in 1893 when Tchaikovsky wrote his last six songs to lyrics by this young unknown poet of German descent. There was a boom in the next two decades in sentimental urban romances, and Ratgauz’s melancholy poems were the perfect expression of what Russian composers were looking for in this vein. By 1917, Ratgauz had 144 poems set to music by contemporaries like Arensky, Ippolitov-Ivanov, Grechaninov, Koreshchenko, and Glière. In the list of Russian poets whose poems were made into songs before 1917, Ratgauz is fifth, ahead of poets like Aleksei Tolstoy, Yakov Polonsky, Aleksei Pleshcheyev, and Feodor Tyutchev, and behind only the top four—Konstantin Balmont, in first place, followed by Alexander Pushkin, Afanasy Fet, and Mikhail Lermontov. As a poet he is not even close to being in the same league as any of these other poets, but Tchaikovsky chose his texts well and wrote powerful music for them. Indeed, some consider Op. 73 to be Tchaikovsky’s finest set of songs.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("T")]), _vm._v("EXT")], 1), _vm._v(". "), _c('b', [_vm._v("Daniíl Maksímovich Ratgáuz")]), _vm._v(", 1893. Title: "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Песня разочарованного")]), _vm._v(" (Song of the disillusioned). First published in "), _c('i', [_vm._v("Ratgauz 1893")]), _vm._v(", p. 104. This book was passed by the censor in Kiev on 9 July 1893, so presumably Rachmaninoff saw the poem after that date. He changed the word order in the first phrase of line 9 to make it more natural, and repeated the first word of line 12 at the end of the song. Not set by any other composers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("ETER")], 1), _vm._v(". Binary. Iambic hexameter, with a caesura (word boundary) after the third foot:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("M")]), _vm._v("USIC")], 1), _vm._v(". 1893. Without opus number. F Minor – A-flat Major. 4/4, [Andante]. For Low Voice: c–f"), _c('sup', [_vm._v("1")]), _vm._v(". First published posthumously in "), _c('i', [_vm._v("Lamm")]), _vm._v(", 1947. No dedication.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("R")]), _vm._v("ECORDINGS")], 1), _vm._v(". Del Grande, Koptchak, Leiferkus, Pirogov, Söderström, Suchkova.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "chtop",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "3%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "87%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "middle"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('td'), _c('td', [_c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("Песня разочарованного")])]), _vm._v(" "), _c('p', {
    staticClass: "cht"
  }, [_c('i', [_vm._v("Song of the disillusioned")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rachmaninoff chose less well. He found this poem in 1893, when it first appeared in print. By that time, he had written Op. 4 and Op. 8, which contain several very good songs. They include sad songs, but nothing to match the extremes of despair and impossible hopes in this text. It is hard to imagine Rachmaninoff sharing these sentiments, except maybe the penultimate line, a wish to bring back the happy summers spent at Ivanovka with the Satins and the Skalon sisters. The song is well shaped, with “portentous repeated quaver octaves” in the bass accompaniment ("), _c('i', [_vm._v("Martyn")]), _vm._v(", 84) to the midpoint of the song, line 7, where there is a shift to a major key, then back to the minor for the last stanza; there is a strong piano postlude of seven bars. It is a big, ambitious song, but he rightly decided not to publish it.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("«Умри!» – твердит мне день, томительный и скучный")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("«Умри!» – мне шепчет ночь таинственною мглой.")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("И в жизни тягостной, с тоскою неразлучный")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Без цели я брожу усталою стопой.")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("«Умри!» – твердил мне ум, когда в душе унылой")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Почуял я намёк на светлый сон любви…")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Но ты, мой нежный друг, мой ангел светлокрылый")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Ты взором ласковым мне всё твердишь: «Живи!»")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("О, как я жить хочу! Как страстно жажду света")]), _vm._v(",")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Возврата пылких грёз, несбыточной мечты!..")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Скажи, как возвратить умчавшееся лето?")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Скажи, как оживить увядшие цветы? Скажи!")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "top",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“Umrí!” – tverdít mne dén’,")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("“Die!” the day keeps saying,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("tamítel’nyj i skúshnyj.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("wearisome and tedious,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("“Umrí!” – mne shépchet nóch")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("“Die!” whispers night")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("taínstvennaju mglój.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("in its mysterious gloom.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I v zhýzni tjágasnaj, s taskóju")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And in a life of hardship, melancholy")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("nerazlúchnyj,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("my inseparable companion,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Bes tséli ja brazhú ustálaju stapój.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I wander aimlessly with weary steps.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("“Umrí!” – tverdíl mne úm,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("“Die!” – my mind kept telling me,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("kagdá v dushé unýlaj")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("when in my downcast soul")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Pachújal ja namjók na svétlyj són ljubví…")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I sensed a hint of love’s bright dream…")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("No tý, moj nézhnyj drúk,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("But you, my gentle friend,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("moj ángel svetlakrýlyj,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("my bright-winged angel,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Ty vzóram láskavym mne fsjo tverdísh:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("With loving gaze keep saying to me:")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("“Zhyví!”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("“Live!”")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("O, kák ja zhýt’ khachú!")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poemt"
  }, [_vm._v("Oh, how I want to live!")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("Kak strásna zházhdu svéta,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("How passionately I long for light,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Vazvráta pýlkikh grjós,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("For the return of ardent wishes,")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("nezbýtachnaj mechtý!..")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("the unattainable dream!..")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Skazhý, kák vazvratít’")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Tell me, how can you bring back")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("umcháfshejesa léta?")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("the summer that has flown away?")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Skazhý, kák azhyvít’")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Tell me, how do you bring to life")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td'), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("uvjátshyje tsvetý? Skazhý!")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("the flowers that have faded? Tell me!")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("But you, my gentle friend")]), _vm._v(", || "), _c('i', [_vm._v("my loving guardian angel…")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a81cd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/018_Chapter_06.vue
// module id = 108
// module chunks = 0